import { render, staticRenderFns } from "./ExtradateForm.vue?vue&type=template&id=57f541e8&scoped=true&"
import script from "./ExtradateForm.vue?vue&type=script&lang=js&"
export * from "./ExtradateForm.vue?vue&type=script&lang=js&"
import style0 from "./ExtradateForm.vue?vue&type=style&index=0&id=57f541e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f541e8",
  null
  
)

export default component.exports